// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3WRNr","actions":"GroupTable_actions__uZqrM","deleteModalFooter":"GroupTable_deleteModalFooter__2nPrL"};